// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".schema-item[data-v-cf593d56] {\n  border-radius: 4px;\n}\n.schema-item[data-v-cf593d56]:hover {\n  background-color: var(--v-gray_10-base);\n  cursor: pointer;\n}", ""]);
// Exports
module.exports = exports;
